import { render, staticRenderFns } from "./SearchedFbaProducts.vue?vue&type=template&id=31dc2832&"
import script from "./SearchedFbaProducts.vue?vue&type=script&lang=js&"
export * from "./SearchedFbaProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports